export const normalizeSuggestionsQuery = (value: string) =>
  value.trim().replace(/\s+/g, ' ')

export const isSuggestionsQuerySettled = (
  searchValue: string,
  debouncedSearchValue: string
) =>
  normalizeSuggestionsQuery(searchValue) ===
  normalizeSuggestionsQuery(debouncedSearchValue)

export const shouldCloseSuggestionsOnScroll = (
  target: EventTarget | null,
  input: HTMLElement | null,
  dropdown: HTMLElement | null
) => {
  if (!(target instanceof Node)) return true
  if (target === input) return false
  return !dropdown?.contains(target)
}
